import React, { FC, ReactNode } from "react";
import cx from "classnames";
import {
  PlusIcon,
  TickIcon as CheckIcon,
} from "assets";
interface Props {
  text?: string;
  isSelected?: boolean;
  onSelect?: () => void;
  children?: ReactNode;
  variant?: "primary" | "secondary";
  id?: string;
}

const PaymentMethodButton: FC<React.PropsWithChildren<Props>> = ({
  text,
  isSelected,
  onSelect,
  children,
  variant = "primary",
  id = "payment-method-button",
}) => {
  const props = {
    className: cx("payment-method", {
      "payment-method--selected": isSelected,
      "payment-method--primary": variant === "primary",
      "payment-method--secondary": variant === "secondary",
    }),
    onClick: onSelect,
    id,
  };

  if (variant === "secondary") {
    return <div {...props}>{children}</div>;
  }

  const dimensions = { width: 32, height: 32 };

  return (
    <div {...props}>
      <span className="payment-method-icon">
        {isSelected ? (
          <CheckIcon {...dimensions} />
        ) : (
          <PlusIcon {...dimensions} />
        )}
      </span>
      {text}
      {children}
    </div>
  );
};

export default PaymentMethodButton;
